import React from 'react';
import { Broadcast } from 'react-broadcast';

import { uniqueId } from 'lodash';

import { getContext } from 'recompose';

export class NotificationsProvider extends React.Component {
  props: {
    children: React.Element,
  };

  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
    };
  }

  static childContextTypes = {
    addNotification: React.PropTypes.func,
    removeNotification: React.PropTypes.func,
  };

  addNotification = (text: string, status: 'success' | 'error' = 'error') => {
    this.setState(({ notifications }) => {
      const id = uniqueId();

      setTimeout(() => this.removeNotification(id), 5000);

      return {
        notifications: [
          ...notifications,
          {
            id,
            content: text,
            status,
          },
        ],
      };
    });
  };

  removeNotification = (id: number) => {
    this.setState(({ notifications }) => {
      const index = notifications.findIndex(
        notification => notification.id === id,
      );

      if (index < 0) {
        return;
      }

      return {
        notifications: [
          ...notifications.slice(0, index),
          ...notifications.slice(index + 1),
        ],
      };
    });
  };

  getChildContext() {
    return {
      addNotification: this.addNotification,
      removeNotification: this.removeNotification,
    };
  }

  render() {
    return (
      <Broadcast channel="notifications" value={this.state.notifications}>
        {this.props.children}
      </Broadcast>
    );
  }
}

const withNotifications = getContext({
  addNotification: React.PropTypes.func,
  removeNotification: React.PropTypes.func,
});

export { withNotifications };
export default NotificationsProvider;



// WEBPACK FOOTER //
// ../src/client/components/NotificationsProvider.js